module.exports = __webpack_public_path__ + "static/media/share.c2f00dc6.svg";